import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import classes from '../appForm/style.module.css'
import Navbar from '../../navbar';
import Header from '../../header';
import { fetchApplication, saveRenewalApplication, updateApplicationData, safePdf, isThunkFulfilled } from '../../../store/reducers/applicationSlice'
import { getSignature, getAttachments } from '../../../store/reducers/fileSlice';
import { setFormFieldData, hideAllPagesExceptCurrentFormPage, prepareHtmlForPdf } from '../../../utility/utility';
import FormHeader from '../forms/formHeader/formHeader';
import AddAttachment from './attachments';
import FormLoader from '../forms/formLoader';
import { useNavigate } from "react-router-dom";
import { showSuccess, showError } from '../../../helpers/toast';
import { createNotification } from '../../../store/reducers/notificationSlice';

const Renewals = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const authToken = user.access_token;
  const params = useParams();
  const application = useSelector((state) => state.applications.application)
  const [pageIds, setPageIds] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [formIds, setFormIds] = useState([]);
  const [signatureImage, setSignatureImage] = useState('')
  const [inputFields, setInputFields] = useState({});
  const [signatureIds, setSignatureIds] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [imageData, setImageData] = useState('');
  const [showAttachments, setShowAttachments] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (dispatch && params.id && authToken) {
      dispatch(fetchApplication({ id: params.id, accessToken: authToken }));
    }
  }, [dispatch, params.id, authToken])

  useEffect(() => {
    const runAsyncFunctions = async () => {
      if (isLoaded && inputFields && user) {
        await setFormFieldData(application.json_data);
        let userId = user.user.id

        // Use Promise.allSettled to handle both API calls gracefully
        const [signatureResult, attachmentsResult] = await Promise.allSettled([
          getSignature({ userId: userId, applicationId: params.id, authToken }),
          getAttachments({ userId: userId, applicationId: params.id, authToken })
        ]);

        // Handle signature result
        if (signatureResult.status === 'fulfilled' && signatureResult.value) {
          setSignatureImage(signatureResult.value);
        } else {
          const error = signatureResult.reason;
          if (error && error.message === 'NOT_FOUND') {
          } else if (error && error.message === 'SERVER_ERROR') {
          } else {
          }
        }

        // Handle attachments result
        if (attachmentsResult.status === 'fulfilled' && attachmentsResult.value) {
          const files = attachmentsResult.value.map(filename => ({ name: filename }));
          setUploadedFiles(files);
        } else {
          const error = attachmentsResult.reason;
          if (error && error.message === 'NOT_FOUND') {
          } else if (error && error.message === 'SERVER_ERROR') {
          } else {
          }
          setUploadedFiles([]);
        }
      }
    };

    runAsyncFunctions();
  }, [isLoaded, user]);

  useEffect(() => {
    if (dispatch && params.id && authToken) {
      dispatch(fetchApplication({ id: params.id, accessToken: authToken }));
    }
  }, [dispatch, params.id, authToken])

  useEffect(() => {
    if (application?.json_data && isLoaded) {
      let jsonFields = {};
      try {
        if (
          typeof application.json_data === "string" &&
          application.json_data.trim().startsWith("{")
        ) {
          jsonFields = JSON.parse(application.json_data);
        } else if (
          typeof application.json_data === "object" &&
          application.json_data !== null
        ) {
          jsonFields = application.json_data;
        } else {
          // Handle cases like [object Object]
          jsonFields = {};
        }
      } catch (e) {
        // Fallback if parsing fails
        console.error('Error parsing json_data:', e);
        jsonFields = {};
      }
      setInputFields(jsonFields);
    }
  }, [application, isLoaded])
  useEffect(() => {
    if (signatureImage != '' && signatureIds.length > 0) {
      signatureIds.forEach(id => {
        const imageInput = document.getElementById(id);
        if (imageInput && imageInput.type === 'image') {
          // Directly set the src of the image input
          let originalWidth = window.getComputedStyle(imageInput).width.replace("px", "")
          let originalTop = window.getComputedStyle(imageInput).top.replace("px", "")
          let height = (originalWidth * 114) / 179;
          imageInput.style.height = height + "px";
          imageInput.style.top = (originalTop - height) + 20 + "px";
          imageInput.src = signatureImage;
          setImageData(signatureImage);
        }
      });
    }
  }, [signatureImage])

  useEffect(() => {
    if (pageIds) {
      hideAllPagesExceptCurrentFormPage(pageIds, currentPage);
    }
  }, [pageIds])

  useEffect(() => {
    if (formIds.length > 0) {
      attachEventHandlers();
    }
  }, [formIds.length]);

  const attachEventHandlers = () => {
    let tempSignatureIds = []

    formIds.forEach(id => {
      const inputField = document.getElementById(id);
      if (inputField.type === 'image') {
        tempSignatureIds.push(id);

      } else if (inputField.type === 'checkbox') {
        inputField.addEventListener('change', handleCheckBoxChange)
      } else {
        inputField.addEventListener('change', handleInputChange);
      }
    });
    setSignatureIds(tempSignatureIds);
  };
  const handleInputChange = (event) => {
    const { id, value } = event.target;

    setInputFields(prevInputFields => ({
      ...prevInputFields,
      [id]: value,
    }));
  };
  const handleCheckBoxChange = (event) => {
    const { id, checked, value } = event.target;

    setInputFields(prevInputFields => {
      // If the checkbox is checked, add it to inputFields
      if (checked) {
        return {
          ...prevInputFields,
          [id]: value,
        };
      } else {
        // If the checkbox is unchecked, remove it from inputFields
        const { [id]: removedValue, ...remainingFields } = prevInputFields;
        return remainingFields;
      }
    })
  };
  const previousPage = () => {
    if (currentPage == pageIds.length + 1) {
      setShowAttachments(false);
      showDiv(currentPage - 1);
      setCurrentPage(currentPage - 1)
    } else {
      if (currentPage - 1 >= 1) {
        hideDiv(currentPage);
        showDiv(currentPage - 1);
        setCurrentPage(currentPage - 1);
      }
    }
  }
  const nextPage = () => {
    if (currentPage + 1 <= pageIds.length) {
      hideDiv(currentPage);
      showDiv(currentPage + 1);
      setCurrentPage(currentPage + 1);
    } else if (currentPage + 1 <= pageIds.length + 1) {
      hideDiv(currentPage);
      setCurrentPage(currentPage + 1);
      setShowAttachments(true);
    }
  }
  const hideDiv = (pageNo) => {
    const pageDiv = document.getElementById("page" + pageNo);
    pageDiv.style.display = "none";
  }
  const showDiv = (pageNo) => {
    const pageDiv = document.getElementById("page" + pageNo);
    pageDiv.style.display = "";
  }
  const handleSubmitWithLoading = async (e) => {
    let htmlForm = document.getElementById("DocumentPDF").outerHTML;

    // Check if application is a draft (newly created) or an existing renewal
    // If state is "draft", update the existing application instead of creating a new one
    const isDraft = application?.state === 'draft';

    let applicationId;

    try {
      if (isDraft) {
        // Update existing draft application
        const response = await dispatch(updateApplicationData({
          token: authToken,
          id: params.id,
          json_data: inputFields,
          state: user.user?.user_role === 'company_admin'
            ? 'in_process'
            : 'application_submitted_by_company_user_to_company',
          userId: user.user.id,
          files: uploadedFiles,
          form: application.name
        }));

        if (!isThunkFulfilled(response)) {
          showError('Failed to submit application. Please try again.');
          return;
        }

        applicationId = params.id; // Use the same ID
      } else {
        // Create renewal for existing approved application
        const renewalResponse = await saveRenewalApplication({
          token: authToken,
          id: params.id,
          json_data: inputFields,
          state: user.user?.user_role === 'company_admin'
            ? 'in_process'
            : 'application_submitted_by_company_user_to_company',
          userId: user.user.id,
          files: uploadedFiles,
          form: application.name
        });

        if (!renewalResponse) {
          console.error('Failed to save renewal');
          showError('Failed to submit application. Please try again.');
          return;
        }

        // Best-effort extraction of new application ID, fall back to current
        applicationId =
          renewalResponse?.id ||
          renewalResponse?.applicationId ||
          renewalResponse?.application_id ||
          params.id;
      }

      // Save PDF with the latest form data
      await dispatch(safePdf({
        htmlForm: prepareHtmlForPdf(htmlForm, inputFields, pageIds),
        user: { id: application.userId || application.user_id || user.user.id },
        id: applicationId,
        token: authToken
      }));

      // Send notifications similar to initial application submission
      if (user.user?.user_role === 'employee') {
        // Employee submitted renewal to company admin
        await dispatch(createNotification({
          user_id: user.user.id,
          applicationId,
          applicationName: application.name,
          status: 'submitted',
          accessToken: authToken,
          sendToCompanyAdmins: true,
          companyName: user.user?.company_name,
          employeeName: user.user?.full_name
        }));
        showSuccess('Application submitted successfully');
      } else {
        // Company admin submitted renewal to Gaming Board
        await dispatch(createNotification({
          user_id: user.user.id,
          applicationId,
          applicationName: application.name,
          status: 'company_submitted',
          accessToken: authToken,
          sendToCompanyAdmins: true,
          sendToGamingBoardAdmins: true,
          sendToGamingBoardReviewers: true,
          sendToGamingBoardViewers: true,
          companyName: user.user?.company_name,
          employeeName: user.user?.full_name
        }));
        showSuccess('Application submitted successfully!');
      }

      if (user.user?.user_role === 'company_admin') {
        navigate('/in-process-applications');
      } else {
        navigate('/in-review');
      }
    } catch (error) {
      console.error('Error submitting renewal application:', error);
      showError('Failed to submit application. Please try again.');
    }
  };

  const saveToDrafts = async (e) => {
    let htmlForm = document.getElementById("DocumentPDF").outerHTML;

    // Check if application is a draft (newly created) or an existing renewal
    const isDraft = application?.state === 'draft';

    let applicationId;

    try {
      if (isDraft) {
        // Update existing draft application
        const response = await dispatch(updateApplicationData({
          token: authToken,
          id: params.id,
          json_data: inputFields,
          state: e,
          userId: user.user.id,
          files: uploadedFiles,
          form: application.name
        }));

        if (!isThunkFulfilled(response)) {
          showError('Failed to save draft. Please try again.');
          return;
        }

        applicationId = params.id; // Use the same ID
      } else {
        // Create renewal for existing approved application
        const renewalResponse = await saveRenewalApplication({
          token: authToken,
          id: params.id,
          json_data: inputFields,
          state: e,
          userId: user.user.id,
          files: uploadedFiles,
          form: application.name
        });

        if (!renewalResponse) {
          console.error('Failed to save renewal draft');
          showError('Failed to save draft. Please try again.');
          return;
        }

        applicationId =
          renewalResponse?.id ||
          renewalResponse?.applicationId ||
          renewalResponse?.application_id ||
          renewalResponse?.newApplicationId ||
          params.id;
      }

      await dispatch(safePdf({
        htmlForm: prepareHtmlForPdf(htmlForm, inputFields, pageIds),
        user: { id: application.userId || application.user_id || user.user.id },
        id: applicationId,
        token: authToken
      }));
    } catch (error) {
      console.error('Error saving draft renewal application:', error);
      showError('Failed to save draft. Please try again.');
    }
  }
  const handlePageChange = (number) => {
    if (number > 0 && number <= pageIds.length + 1) {
      if (number == pageIds.length + 1) {
        hideDiv(currentPage);
        setCurrentPage(number);
        setShowAttachments(true);
      } else {
        if (currentPage == pageIds.length + 1) {
          setShowAttachments(false)
          showDiv(number)
          setCurrentPage(number)
        } else {
          hideDiv(currentPage);
          showDiv(number);
          setCurrentPage(number);
        }
      }
    }
  }
  return (
    <div>
      <Navbar />
      <Header />
      <div className='wrapper'>
        <div className='boxAppBoard boxWhite'>
          <div className="stickyFormHeader">
            <FormHeader applicationName={application.name} nextPage={nextPage} previousPage={previousPage}
              currentPage={currentPage} totalPages={pageIds.length + 1} handleSubmitWithLoading={handleSubmitWithLoading}
              saveToDrafts={saveToDrafts} handlePageChange={handlePageChange} />
          </div>

          <div className={classes['board-content']}>
            {application && <FormLoader applicationName={application.name} setFormIds={setFormIds} setPageIds={setPageIds} setIsLoaded={setIsLoaded} />}

          </div>

          {showAttachments && <AddAttachment signatureIds={signatureIds} setUploadedFiles={setUploadedFiles} uploadedFiles={uploadedFiles} />}
        </div>
      </div>
    </div>
  )
}
export default Renewals